import { H4 } from '@snsw/react-component-library';
import React from 'react';
import { mapPlantDesignSummary } from 'plantDesign/utils/PlantDesignSummaryFormatHelper';
import styles from '../PlantDesignReview.module.scss';

export const DesignDetailsReview = (props) => {
  const { data = {}, refData } = props;

  const formattedDesignDetails = mapPlantDesignSummary(data, refData);

  // TODO: Prevent this to be rendered not to cause the unique key prop warning.
  return (
    <>
      {data && refData && (
        <>
          <H4>Plant design details</H4>

          {formattedDesignDetails.map(
            (prop) =>
              prop.value && (
                <div key={prop.text}>
                  <div className={styles.summaryLabel}>{prop.text}</div>
                  <div className={styles.summaryValue}>{prop.value}</div>
                </div>
              ),
          )}
        </>
      )}
    </>
  );
};
